export default [
    {
        acc_eco_decree: {id: 1, code_bde: 'S', name_ca: 'Sí', name_en: 'Yes', name_es: 'Sí'},
        acc_mortgage_market_law: {id: 1, code_bde: 'S', name_ca: 'Sí', name_en: 'Yes', name_es: 'Sí'},
        code_bde: 'A',
        id: 1,
        name_ca: 'Garantia hipotecària de crèdits o préstecs (ECO 2a)',
        name_en: 'Mortgage-secured loan guarantees (ECO 2a)',
        name_es: 'Garantía hipotecaria de créditos o préstamos (ECO 2a)',
        default_notes: {
            name_ca: 'La taxació SÍ és vàlida per a fins hipotecaris perquè s\'utilitza el criteri de valor garantit en el temps mitjançant un ajust del valor de mercat',
            name_en: 'The appraisal IS valid for mortgage guarantees since the criteria for the value-over-time-guarantee is applied through an adjustment of the market value',
            name_es: 'La tasación SÍ es válida para fines hipotecarios porque se utiliza el criterio del valor garantizado en el tiempo mediante ajuste del valor de mercado'
        },
        default_reduction_pct: -15
    },
    {
        acc_eco_decree: {id: 1, code_bde: 'S', name_ca: 'Sí', name_en: 'Yes', name_es: 'Sí'},
        acc_mortgage_market_law: {id: 1, code_bde: 'S', name_ca: 'Sí', name_en: 'Yes', name_es: 'Sí'},
        code_bde: 'B',
        id: 2,
        name_ca: 'Cobertura de provisions tècniques de les entitats asseguradores (ECO 2b)',
        name_en: 'Insurance companies technical provision coverage (ECO 2b)',
        name_es: 'Cobertura de provisiones técnicas de las entidades aseguradoras (ECO 2b)',
        default_notes: {
            name_ca: 'La taxació SÍ és vàlida per a fins hipotecaris perquè s\'utilitza el criteri de valor garantit en el temps mitjançant un ajust del valor de mercat',
            name_en: 'The appraisal IS valid for mortgage guarantees since the criteria for the value-over-time-guarantee is applied through an adjustment of the market value',
            name_es: 'La tasación SÍ es válida para fines hipotecarios porque se utiliza el criterio del valor garantizado en el tiempo mediante ajuste del valor de mercado'
        },
        default_reduction_pct: -15
    },
    {
        acc_eco_decree: {id: 1, code_bde: 'S', name_ca: 'Sí', name_en: 'Yes', name_es: 'Sí'},
        acc_mortgage_market_law: {id: 1, code_bde: 'S', name_ca: 'Sí', name_en: 'Yes', name_es: 'Sí'},
        code_bde: 'C',
        id: 3,
        name_ca: 'Determinació del patrimoni de les institucions d\'inversió col·lectiva immobiliàries (ECO 2c)',
        name_en: 'Net worth determination of collective investment institutions (ECO 2c)',
        name_es: 'Determinación del patrimonio de las instituciones de inversión colectiva inmobiliarias  (ECO 2c)',
        default_notes: {
            name_ca: 'La taxació SÍ és vàlida per a fins hipotecaris perquè s\'utilitza el criteri de valor garantit en el temps mitjançant un ajust del valor de mercat',
            name_en: 'The appraisal IS valid for mortgage guarantees since the criteria for the value-over-time-guarantee is applied through an adjustment of the market value',
            name_es: 'La tasación SÍ es válida para fines hipotecarios porque se utiliza el criterio del valor garantizado en el tiempo mediante ajuste del valor de mercado'
        },
        default_reduction_pct: -15
    },
    {
        acc_eco_decree: {id: 1, code_bde: 'S', name_ca: 'Sí', name_en: 'Yes', name_es: 'Sí'},
        acc_mortgage_market_law: {id: 1, code_bde: 'S', name_ca: 'Sí', name_en: 'Yes', name_es: 'Sí'},
        code_bde: 'D',
        id: 4,
        name_ca: 'Determinació del patrimoni immobiliari dels Fons de Pensions (ECO 2d)',
        name_en: 'Net worth determination of the state pension fund property holdings (ECO 2d)',
        name_es: 'Determinación del patrimonio inmobiliario del Fondo de Pensiones (ECO 2d)',
        default_notes: {
            name_ca: 'La taxació SÍ és vàlida per a fins hipotecaris perquè s\'utilitza el criteri de valor garantit en el temps mitjançant un ajust del valor de mercat',
            name_en: 'The appraisal IS valid for mortgage guarantees since the criteria for the value-over-time-guarantee is applied through an adjustment of the market value',
            name_es: 'La tasación SÍ es válida para fines hipotecarios porque se utiliza el criterio del valor garantizado en el tiempo mediante ajuste del valor de mercado'
        },
        default_reduction_pct: -15
    },
    {
        acc_eco_decree: {id: 2, code_bde: 'N', name_ca: 'No', name_en: 'No', name_es: 'No'},
        acc_mortgage_market_law: {id: 2, code_bde: 'N', name_ca: 'No', name_en: 'No', name_es: 'No'},
        code_bde: 'O',
        id: 5,
        name_ca: 'Adquisició o venda',
        name_en: 'Purchase or sale',
        name_es: 'Adquisición o venta',
        default_notes: {
            name_ca: 'La taxació NO és vàlida per a fins hipotecaris perquè no s\'utilitza el criteri de valor garantit en el temps, si més no el valor en el dia de la data consignada',
            name_en: 'The appraisal is NOT valid for mortgage guarantees since the criteria for the value-over-time-guarantee is not applied',
            name_es: 'La tasación NO es válida para fines hipotecarios porque no se utiliza el criterio del valor garantizado en el tiempo, sino el valor en el día de la fecha consignada'
        },
        default_reduction_pct: 0
    },
    {
        acc_eco_decree: {id: 2, code_bde: 'N', name_ca: 'No', name_en: 'No', name_es: 'No'},
        acc_mortgage_market_law: {id: 2, code_bde: 'N', name_ca: 'No', name_en: 'No', name_es: 'No'},
        code_bde: 'O',
        id: 6,
        name_ca: 'Expedients expropiatoris',
        name_en: 'Expropriation proceedings',
        name_es: 'Expedientes expropiatorios',
        obs_ca: 'La taxació NO és vàlida per a fins hipotecaris perquè no s\'utilitza el criteri de valor garantit en el temps, si més no el valor en el dia de la data consignada',
        obs_en: 'The appraisal is NOT valid for mortgage guarantees since the criteria for the value-over-time-guarantee is not applied',
        obs_es: 'La tasación NO es válida para fines hipotecarios porque no se utiliza el criterio del valor garantizado en el tiempo, sino el valor en el día de la fecha consignada',
        default_reduction_pct: 0
    },
    {
        acc_eco_decree: {id: 2, code_bde: 'N', name_ca: 'No', name_en: 'No', name_es: 'No'},
        acc_mortgage_market_law: {id: 2, code_bde: 'N', name_ca: 'No', name_en: 'No', name_es: 'No'},
        code_bde: 'O',
        id: 7,
        name_ca: 'Assegurament de danys',
        name_en: 'Damage insuring',
        name_es: 'Aseguramiento de daños',
        default_notes: {
            name_ca: 'La taxació NO és vàlida per a fins hipotecaris perquè no s\'utilitza el criteri de valor garantit en el temps, si més no el valor en el dia de la data consignada',
            name_en: 'The appraisal is NOT valid for mortgage guarantees since the criteria for the value-over-time-guarantee is not applied',
            name_es: 'La tasación NO es válida para fines hipotecarios porque no se utiliza el criterio del valor garantizado en el tiempo, sino el valor en el día de la fecha consignada',
        },
        default_reduction_pct: 0
    },
    {
        acc_eco_decree: {id: 2, code_bde: 'N', name_ca: 'No', name_en: 'No', name_es: 'No'},
        acc_mortgage_market_law: {id: 2, code_bde: 'N', name_ca: 'No', name_en: 'No', name_es: 'No'},
        code_bde: 'O',
        id: 8,
        name_ca: 'Determinació possible lloguer',
        name_en: 'Possible rent determination',
        name_es: 'Determinación posible alquiler',
        default_notes: {
            name_ca: 'La taxació NO és vàlida per a fins hipotecaris perquè no s\'utilitza el criteri de valor garantit en el temps, si més no el valor en el dia de la data consignada',
            name_en: 'The appraisal is NOT valid for mortgage guarantees since the criteria for the value-over-time-guarantee is not applied',
            name_es: 'La tasación NO es válida para fines hipotecarios porque no se utiliza el criterio del valor garantizado en el tiempo, sino el valor en el día de la fecha consignada'
        },
        default_reduction_pct: 0
    }
]



// WEBPACK FOOTER //
// ./src/options/appraisal_purposes.js